import React, { useCallback } from 'react';
import dynamic from 'next/dynamic';
import { useIdleCallback } from '@shopify/react-idle';
import { Loader } from '@/components';
import { MetaData } from '@/containers';
import {
	fetchSpecialOffers,
	getSpecialOffersData,
} from '@fh-components/fh-js-api-core/store/slices/pagesSlice';
import qs from 'qs';
import redirectFirstPage from '@/lib/redirectFirstPage';
import { handleError } from '@/lib/handleError';
import ecommerce from '@/seo/Ecommerce';

const SpecialOffersPage = dynamic(() => import('../../layouts/SpecialOffersPage'), {
	loading: () => <Loader />,
});

export default function NextSpecialOffersPage(props) {
	const setPageType = useCallback(() => {
		ecommerce.setPageType(ecommerce.PAGE_TYPES.SPECIAL);
	}, []);

	useIdleCallback(setPageType);

	return (
		<>
			<MetaData
				title='Акции | FH.BY'
				description='Текущие и будущие Акции интернет-магазина FH.BY!'
				seo={props?.seo}
				withPage
			/>

			<SpecialOffersPage {...props} />
		</>
	);
}

NextSpecialOffersPage.getInitialProps = async ({ reduxStore, query, res, asPath }) => {
	const { page } = qs.parse(query);
	redirectFirstPage({ page, res, asPath });

	await reduxStore.dispatch(fetchSpecialOffers({ page: page || 1, per_page: 6 }));

	const pageData = getSpecialOffersData(reduxStore.getState());

	handleError(pageData.error);

	return pageData?.data ?? {};
};
